export class HeartBeatModel {
    constructor() {
        this.uid = '';
        this.beatTime = '';
        this.recentActivityTime = null;
    }
}
export default class HeartBeat extends HeartBeatModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
